import Index from '../views/pages/Index'
import MainLayout from '../views/layouts/Main'
import { loggedIn } from './authorization/conditions'

export default [
  {
    path: '',
    component: MainLayout,
    children: [
      {
        path: '',
        redirect: { name: 'Login' },
        name: 'Index',
        component: Index,
      },
    ],
  },
  {
    path: '',
    component: () => import(/* webpackChunkName: "auth" */ '../views/layouts/Auth'),
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/Login'),
      },
      {
        path: '/login/forgot',
        name: 'LoginForgot',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/LoginForgot'),
      },
      {
        path: '/login/reset',
        name: 'LoginReset',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/LoginReset'),
      },
      // {
      //   path: '/signup',
      //   name: 'Signup',
      //   component: () => import(/* webpackChunkName: "auth" */ '../views/pages/Signup'),
      // },
      // {
      //   path: '/signup/success',
      //   name: 'SignupSuccess',
      //   component: () => import(/* webpackChunkName: "auth" */ '../views/pages/SignupSuccess'),
      // },
      // {
      //   path: '/signup/verify',
      //   name: 'SignupVerify',
      //   component: () => import(/* webpackChunkName: "auth" */ '../views/pages/SignupVerify'),
      // },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/Logout'),
      },
    ],
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    auth: loggedIn(),
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/layouts/Board'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/pages/Dashboard'),
      },
    ],
  },
  {
    path: '/dashboardnew',
    auth: loggedIn(),
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/layouts/Board'),
    children: [
      {
        path: '',
        name: 'DashboardNew',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/pages/DashboardNew'),
      },
    ],
  },
]
